import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';

import RenderDropdown from 'forms/RenderDropdown';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { makeSelectOptions } from './selectors';

interface OwnProps {
    name: string;
    validate?: any;
    nullOnUnmount?: boolean;
    placeholder?: string;
    productId: ProductId;
}

interface ConnectedProps {
    options: ReturnType<ReturnType<typeof makeSelectOptions>>;
}

export type Props = OwnProps & ConnectedProps;

export class ProductRatePerUnitTypeDropdownComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const {
            name,
            validate,
            nullOnUnmount = false,
            placeholder,
            productId,
            options
        } = this.props;

        if (productId) {
            return (
                <Field
                    component={RenderDropdown as any}
                    subscription={{
                        value: true,
                        touched: true,
                        error: true
                    }}
                    name={name}
                    label="Rate unit"
                    fluid
                    search
                    selection
                    selectOnBlur={false}
                    validate={validate}
                    options={options}
                    nullOnUnmount={nullOnUnmount}
                    placeholder={placeholder}
                    defaultValue="Ha"
                />
            );
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: makeSelectOptions()
});

export default connect(mapStateToProps)(
    ProductRatePerUnitTypeDropdownComponent
);
